/** Faces used for titles (Unbounded) and UI body (Urbanist). */
const APP_FONT_FACES = [
  '800 1.75rem "Unbounded"',
  '700 1.75rem "Unbounded"',
  '400 1rem "Urbanist"',
  '500 1rem "Urbanist"',
  '600 1rem "Urbanist"',
  '700 1rem "Urbanist"',
] as const;

/** Don't block the UI forever if the font CDN is slow. */
export const APP_FONTS_WAIT_MS = 2500;

let fontsPromise: Promise<void> | null = null;

/**
 * Warm the app's real typefaces so gallery titles / login don't FOUT
 * from system-ui (or another fallback) into Unbounded/Urbanist.
 */
export function ensureAppFonts(): Promise<void> {
  if (!fontsPromise) {
    fontsPromise = (async () => {
      if (typeof document === 'undefined' || !document.fonts?.load) return;
      await Promise.race([
        Promise.all(
          APP_FONT_FACES.map((face) =>
            document.fonts.load(face).then(
              () => undefined,
              () => undefined
            )
          )
        ),
        new Promise<void>((resolve) => {
          window.setTimeout(resolve, APP_FONTS_WAIT_MS);
        }),
      ]);
    })();
  }
  return fontsPromise;
}

// Start as soon as this module evaluates (before React effects).
if (typeof window !== 'undefined') {
  void ensureAppFonts();
}
